import type { Principle } from '../types/content';

export const employerCommitments: Principle[] = [
  {
    title: 'A shortlist worth your time',
    description: 'Typically four to six rigorously assessed, genuinely interested candidates — never a stack of CVs.',
  },
  {
    title: 'Clear market intelligence',
    description: 'Compensation benchmarks, talent availability, and competitor insight shared as the search unfolds.',
  },
  {
    title: 'Confidential handling',
    description: 'Discreet approaches that protect your organization, your incumbents, and your strategy.',
  },
  {
    title: 'Support through transition',
    description: 'We stay close through offer, onboarding, and the new leader’s early months in role.',
  },
];

export const engagementModels: Principle[] = [
  {
    title: 'Retained executive search',
    description: 'Our core service for board, C-suite, and senior leadership roles, run by a dedicated partner-led team.',
  },
  {
    title: 'Leadership assessment',
    description: 'Independent evaluation of internal candidates or full leadership teams ahead of key decisions.',
  },
  {
    title: 'Interim leadership',
    description: 'Rapid access to experienced executives for transformation, turnaround, or leadership gaps.',
  },
  {
    title: 'Succession advisory',
    description: 'Ongoing partnership to build a resilient pipeline for the roles that matter most.',
  },
];
